// extracted by mini-css-extract-plugin
module.exports = {"detail-btn":"DetailBtn2_detail-btn__1FNMg","detail-btn-icon":"DetailBtn2_detail-btn-icon__2uQ9n","normal":"DetailBtn2_normal__16gx_","hover":"DetailBtn2_hover__3FLqj"};